import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationService} from '../../services/navigation/navigation.service';
import {PageNames} from '../../shared/page-names.enum';
import {NavigableComponent} from '../../model/navigable-component';
import {OmapiIdConstants} from '../../shared/omapi-id-constants';
import {OrderingModalManagerComponent} from '../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {Order} from '../../model/order';
import {Emitter} from '../../shared/utils/emitter/emitter';
import {EmitterConstants} from '../../shared/emitter-constants';
import {AnalyticsService} from '../../services/analytics/analytics.service';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';
import {DtvCatalogUtils} from '../../utils/dtv-catalog/dtv-catalog.utils';

@Component({
  selector: 'app-play-more-details',
  templateUrl: './play-more-details.component.html',
  styleUrls: ['./play-more-details.component.less']
})
export class PlayMoreDetailsComponent extends NavigableComponent implements OnInit, AfterViewInit, OnDestroy {

  pack: TvShopEntertainmentPack;
  packs: TvShopEntertainmentPack[];
  order: Order;

  @ViewChild('productdetailcontent', {read: ElementRef})
  productDetailContentElement: ElementRef;

  @ViewChild('orderModal')
  private orderingModal: OrderingModalManagerComponent;

  constructor(protected navigationService: NavigationService,
              private changeDetector: ChangeDetectorRef,
              private stateService: TvShopStateService,
              private analyticsService: AnalyticsService) {
    super(navigationService);
  }

  ngOnInit() {
    this.navigationService.setCurrentPageComponent(PageNames.DETAIL_PAGE_INTRO);
    this.packs = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
    this.pack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(this.packs, OmapiIdConstants.PLAY_MORE);
    this.analyticsService.onDetailPage([OmapiIdConstants.PLAY_MORE]);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.navigationService.clearNavigation();
  }

  ngAfterViewInit() {
    this.navigationService.resetNavigation();
    this.changeDetector.detectChanges();
    this.navigationService.registerPageElement(this.productDetailContentElement);

    if (this.pack && this.pack.isUpgrade) {
      const subPack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(this.packs, OmapiIdConstants.STREAMZ);
      if (subPack.hasTrial) {
        Emitter.of(EmitterConstants.DOWNGRADE_PACK_IS_TRIAL).emit(true);
      }
    }
  }

  openOrderModal(event: Order): void {
    this.order = event;
    this.orderingModal.openModal();
  }

}
